import {
    useStyles,
    FilterContentLayout,
    Caption,
    Checkbox,
    pxToRem,
    useTheme,
} from '@archipro-design/aria';
import * as S from './BoardListFilterDrawerContent.style';
import type {
    BoardOwnerTypeFilter,
    FilterItemsWithCount,
} from '~/modules/design-board/type';
import { useState } from 'react';
import { useNavigate } from '@remix-run/react';
import { DESIGN_BOARD_HOME_LINK } from '~/modules/design-board/config';
import { pluralize } from '~/utils';
import { useSaveToDesignBoardContext } from '~/modules/design-board/component/context';

export const BoardListFilterDrawerContent = ({
    itemsWithCount,
    roleType,
}: {
    itemsWithCount: FilterItemsWithCount[];
    roleType?: BoardOwnerTypeFilter['type'];
}) => {
    const theme = useTheme();
    const { css } = useStyles();
    const navigate = useNavigate();
    const { dispatch } = useSaveToDesignBoardContext();
    const [selectedType, setSelectedType] = useState(roleType);
    const selectedTypeCount =
        itemsWithCount?.find((item) => item.type === selectedType)?.count || 0;

    const onClose = () => {
        dispatch({ type: 'CloseDrawer' });
    };

    const onClickCheckbox = (item: FilterItemsWithCount) => {
        setSelectedType(item.type);
    };

    const onClickViewBoardBtn = () => {
        const link = itemsWithCount?.find(
            (item) => item.type === selectedType
        )?.link;
        if (link) {
            navigate(DESIGN_BOARD_HOME_LINK + link, { replace: true });
        }
        onClose();
    };

    return (
        <div className={css(S.FilterContentLayoutWrapper)}>
            <FilterContentLayout
                title="Filters"
                submitButton={{
                    children: `VIEW ${pluralize(selectedTypeCount, [
                        'BOARD',
                        'BOARDS',
                    ])}`,
                    onClick: onClickViewBoardBtn,
                }}
                closeButton={{}}
                headerAction=""
                content={
                    <div className={css(S.FilterContentLayoutContent)}>
                        <Caption variant="03">{`FILTER BY`}</Caption>

                        {itemsWithCount?.map((item, index) => {
                            return (
                                <Checkbox
                                    key={index}
                                    checked={item.type === selectedType}
                                    onChange={() => onClickCheckbox(item)}
                                    indicator={{
                                        kind: 'radio',
                                        indicator: {
                                            variables: {
                                                border: `1px solid ${theme.siteVariables.colors.charcoal[250]}`,
                                                size: pxToRem(14),
                                                checkedBackgroundColor:
                                                    theme.siteVariables.colors
                                                        .charcoal[250],
                                            },
                                        },
                                    }}
                                    label={{
                                        children: item.title,
                                        variables: {
                                            fontSize: pxToRem(16),
                                            letterSpacing: 'normal',
                                        },
                                    }}
                                    variables={{
                                        labelLineHeight: pxToRem(40),
                                        radioIndicatorLabelGap: pxToRem(6),
                                        radioIndicatorLabelCheckedGap:
                                            pxToRem(6),
                                    }}
                                    disabled={item.count < 1}
                                />
                            );
                        })}
                    </div>
                }
                onClose={onClose}
            />
        </div>
    );
};
